import { z } from 'zod';
export const deploymentStatusSchema = z.enum([
    'PENDING',
    'IN_PROGRESS',
    'SUCCESS',
    'FAILED',
    'CANCELED',
]);
export const terminalDeploymentStatuses = [
    'SUCCESS',
    'FAILED',
    'CANCELED',
];
export const isTerminalDeploymentStatus = (status) => terminalDeploymentStatuses.includes(status);
export const allDeploymentStatuses = [
    ...deploymentStatusSchema.options,
];
export const deploymentStatusEnum = deploymentStatusSchema.enum;
export const configUpdateNotificationSchema = z.object({
    message: z.string(),
    updatedBy: z.string(),
    timestamp: z.string().optional(),
    deploymentId: z.string().uuid().optional(),
});
export const deploymentSmrtVersionSchema = z.object({
    subgraphName: z.string().min(1),
    smrtVersion: z.string().min(1),
    smrtIri: z.string(),
});
export const updateDeploymentProgressSchema = z.object({
    status: deploymentStatusSchema.optional(),
    logsAppend: z.string().optional(),
    smrtVersions: z.array(deploymentSmrtVersionSchema).optional(),
});
export const deployedByUserSchema = z.object({
    email: z.string(),
    name: z.string().nullable().optional(),
});
export const deploymentConfigRefSchema = z
    .object({
    id: z.string().uuid(),
    createdDate: z.string(),
})
    .optional()
    .nullable();
export const customerDataApiDeploymentSchema = z.object({
    id: z.string().uuid(),
    configId: z.string().uuid(),
    config: deploymentConfigRefSchema,
    status: deploymentStatusSchema,
    attempt: z.number().int().optional(),
    logs: z.string().nullable().optional(),
    startedAt: z.string(),
    completedAt: z.string().nullable().optional(),
    canceledAt: z.string().nullable().optional(),
    canceledByUserId: z.string().uuid().nullable().optional(),
    canceledByUser: deployedByUserSchema.nullable().optional(),
    lastProgressAt: z.string().optional(),
    deployedByUserId: z.string().uuid(),
    deployedByUser: deployedByUserSchema.nullable().optional(),
    isActive: z.boolean().optional(),
    smrtVersions: z.array(deploymentSmrtVersionSchema).optional(),
});
export const gatewaySupergraphReloadResultSchema = z.object({
    ok: z.boolean(),
    included: z.array(z.string()),
    excluded: z.array(z.object({ name: z.string(), reason: z.string() })),
    degraded: z.boolean(),
    error: z.string().nullish(),
});
//# sourceMappingURL=CustomerDataApiDeployment.js.map